module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 126.c23777d8.png";